// Mobile Safari fix: fire change immediately on tap
document.addEventListener('touchend', (e) => {
  const el = e.target.closest('.upsell-enable');
  if (!el) return;
  el.dispatchEvent(new Event('change', { bubbles: true }));
});

// Auto-toggle ON/OFF for extended-warranty block
document.addEventListener('click', (e) => {
  const block = e.target.closest('.upsell-product-block[data-product-type="extended-warranty"]');
  if (!block) return;

  const toggle = block.querySelector('.upsell-enable');
  if (!toggle) return;

  // Detect clicks on the toggle OR its label/wrapper
  const toggleWrapper = toggle.closest('label') || toggle;
  if (e.target === toggle || toggleWrapper.contains(e.target)) {
    // User is manually toggling → do nothing
    return;
  }

  // Clicking anywhere else inside the block → toggle ON/OFF
  toggle.checked = !toggle.checked;

  // Fire change event so Shopify updates price/variants
  toggle.dispatchEvent(new Event('change', { bubbles: true }));
});


  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.variant-btn');
    if (!btn) return;

    const block = btn.closest('.upsell-product-block');
    const variantId = btn.dataset.variant;

    // Update hidden input
    const hidden = block.querySelector('input[name^="selected_variant_"]');
    if (hidden) hidden.value = variantId;

    // Visual selection
    block.querySelectorAll('.variant-btn').forEach((b) => b.classList.remove('selected'));
    btn.classList.add('selected');

    // Auto-enable toggle
    const toggle = block.querySelector('.upsell-enable');
    const isNameplate = block.dataset.productType === 'nameplate';
    if (toggle && !isNameplate) toggle.checked = true;

    // Update featured image
    const featured = block.querySelector('.p-featured-img');
    const variantImg = btn.querySelector('img');
    if (featured && variantImg) {
      featured.src = variantImg.src;
    }

    // Update price
    const price = block.querySelector('.p-main-price');
    const priceEl = btn.querySelector('.variant-btn-price');
    if (price && priceEl) {
      price.textContent = priceEl.textContent;
    }

    // Update selected variant text
    const variantTitle = block.querySelector('.p-selected-variant');
    const titleEl = btn.querySelector('.variant-btn-title');
    if (variantTitle && titleEl) {
      variantTitle.textContent = ': ' + titleEl.textContent;
    }

    // Close dropdown if open
    const details = block.querySelector('details');
    if (details) details.removeAttribute('open');
  });

  document.addEventListener('input', (e) => {
    const input = e.target.closest('.nameplate-input');
    if (!input) return;

    const block = input.closest('.upsell-product-block');
    const toggle = block.querySelector('.upsell-enable');

    if (!input.value.trim()) {
      toggle.checked = false;
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const nameplateBlock = document.querySelector('.upsell-product-block[data-product-type="nameplate"]');
    if (nameplateBlock) {
      const nameplateToggle = nameplateBlock.querySelector('.upsell-enable');
      const nameplateInput = nameplateBlock.querySelector('.nameplate-input');

      nameplateToggle.addEventListener('change', () => {
        const len = nameplateInput.value.trim().length;

        if (nameplateToggle.checked && len < 2) {
          nameplateToggle.checked = false;
          nameplateInput.setCustomValidity('Please enter at least 2 characters.');
          nameplateInput.reportValidity();
          nameplateInput.setCustomValidity('');
        }

        if (nameplateToggle.checked && /[^A-Za-z]/.test( nameplateInput.value.trim())) {
        nameplateToggle.checked = false;
        nameplateInput.setCustomValidity("Only Latin letters (A–Z) are allowed.");
        nameplateInput.reportValidity();
        nameplateInput.setCustomValidity("");
      }
      
      });

      nameplateInput.addEventListener('input', () => {
      const value = nameplateInput.value.trim();
      const hasNonLatin = /[^A-Za-z]/.test(value);
      const len = value.length;

      if (hasNonLatin) {
        nameplateInput.setCustomValidity("Only Latin letters (A–Z) are allowed.");
        nameplateToggle.checked = false;
        nameplateInput.reportValidity();
      } else {
        nameplateInput.setCustomValidity("");
      }

  
      nameplateToggle.checked = len >= 2 && !hasNonLatin;
    });

    }
  });

  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.js-product-add');
    if (!addBtn) return;

    const allItems = [];

    document.querySelectorAll('.upsell-product-block').forEach((block, index) => {
      const toggle = block.querySelector('.upsell-enable');
      const hidden = block.querySelector('input[name^="selected_variant_"]');
      const type = block.dataset.productType;

      if (!toggle || !hidden) {
        return;
      }

      const variantId = hidden.value.trim();

      if (!variantId || !toggle.checked) {
        return;
      }

      if (type === 'nameplate') {
        const nameInput = block.querySelector('.nameplate-input');

        if (!nameInput || !nameInput.value.trim()) {
          return;
        }

        const item = {
          id: Number(variantId),
          quantity: 1,
          ['properties[Custom Name]']: nameInput.value.trim(),
        };

        allItems.push(item);
        return;
      }

      if (type === 'extended-warranty') {
        allItems.push({ id: Number(variantId), quantity: 1 });
        return;
      }

      allItems.push({ id: Number(variantId), quantity: 1 });
    });

    if (allItems.length > 0 && window.Cart.add) {
      window.Cart.add(allItems);
    }
  });

  const container = document.querySelector('.upsell-variant-buttons.upsell-swatches');
  const arrowRight = document.querySelector('.scroll-arrow-right');
  const arrowLeft = document.querySelector('.scroll-arrow-left');

  if (container && arrowRight && arrowLeft) {
    const SCROLL_STEP = 70;

    container.style.scrollBehavior = 'smooth';
    [arrowRight, arrowLeft].forEach((arrow) => {
      arrow.style.pointerEvents = 'auto';
      arrow.style.cursor = 'pointer';
    });

    const updateArrowVisibility = () => {
      const hasOverflow = container.scrollWidth > container.clientWidth;

      if (!hasOverflow) {
        arrowRight.style.setProperty('display', 'none', 'important');
        arrowLeft.style.setProperty('display', 'none', 'important');
        return;
      }

      const maxScroll = container.scrollWidth - container.clientWidth;
      const atStart = container.scrollLeft <= 0;
      const atEnd = container.scrollLeft >= maxScroll - 1;

      // flip logic:
      // left arrow: hidden at start, visible otherwise
      // right arrow: hidden at end, visible otherwise
      arrowLeft.style.setProperty('display', atStart ? 'none' : 'flex', 'important');
      arrowRight.style.setProperty('display', atEnd ? 'none' : 'flex', 'important');
    };

    arrowRight.addEventListener('click', () => {
      container.scrollBy({ left: SCROLL_STEP, behavior: 'smooth' });
    });

    arrowLeft.addEventListener('click', () => {
      container.scrollBy({ left: -SCROLL_STEP, behavior: 'smooth' });
    });

    container.addEventListener('scroll', updateArrowVisibility);

    updateArrowVisibility();
    new ResizeObserver(updateArrowVisibility).observe(container);
    new MutationObserver(updateArrowVisibility).observe(container, { childList: true, subtree: true });
  }

  // handle toggle clicks and body clicks to expand the upsell
  document.addEventListener('click', (e) => {
  const header = e.target.closest('.upsell-product-block[data-product-type="nameplate"] .upsell-header');
  if (!header) return;

  const block = header.closest('.upsell-product-block');
  const collapsible = block.querySelector('.nameplate-collapsible');
  if (!collapsible) return;

  if (e.target.closest('.upsell-enable') || e.target.closest('.toggle-slider')) {
    collapsible.style.display = 'block';
    return;
  }

  const isClosed = getComputedStyle(collapsible).display === 'none';
  collapsible.style.display = isClosed ? 'block' : 'none';
});

document.addEventListener('change', (e) => {
  const toggle = e.target.closest('.upsell-product-block[data-product-type="nameplate"] .upsell-enable');
  if (!toggle) return;

  const block = toggle.closest('.upsell-product-block');
  const collapsible = block.querySelector('.nameplate-collapsible');
  if (!collapsible) return;

  collapsible.style.display = 'block';
});
